import { ContractSellerEditFormValues } from "./types";

export const initialContractSellerEditForm: ContractSellerEditFormValues = {
  lessorCompanyName: null,
  lessorPersonalIdentificationNumber: null,
  lessorHeadquartersAddress: null,
  lessorSalesPersonName: null,
  lessorPhoneNumber: null,
  lessorTransactionAccountNumber: null,
};
